import React from 'react';
import ProfileForm from './ProfileForm';

const EditProfile = () => {
  return <ProfileForm />;
};

export default EditProfile;
